/**
 * The server wraps a 4xx body as `HTTP error <status>: <json>`; unwrap it to the reason
 * an operator can read. Non-wrapped messages pass through unchanged.
 */
export function extractErrorReason(error: unknown): string {
  const message = error instanceof Error ? error.message : String(error);
  const wrapped = message.match(/^HTTP error \d+: (.*)$/s);
  if (!wrapped) {
    return message;
  }
  try {
    const body = JSON.parse(wrapped[1]);
    const reason = body?.error ?? body?.message;
    return reason ? String(reason) : wrapped[1];
  } catch {
    return wrapped[1];
  }
}
